import { Chips, type IChipsOption } from '@cian/ui-kit';

import { type FC, useMemo } from 'react';

import { type SeriaPlusScheme } from '../../settings/seriaPlusTypes';

import styles from './SeriaPlusHeader.css';

type SeriaPlusHeaderProps = {
  activeTabIndex: number;
  blockId: string;
  title: string;
  tabs: SeriaPlusScheme['tabs'];
  onTabChange: (selectedTabIndexes: number[]) => void;
};

export const SeriaPlusHeader: FC<SeriaPlusHeaderProps> = props => {
  const { activeTabIndex, blockId, title, tabs, onTabChange } = props;
  const tabOptions = useMemo<IChipsOption<number>[]>(
    () =>
      tabs.map((tab, index) => ({
        dataTestId: 'seria-plus-carousel-tab',
        label: tab.title,
        value: index,
      })),
    [tabs],
  );

  return (
    <header className={styles['header']}>
      <h2 className={styles['title']} data-testid={`${blockId}-header--title`}>
        {title}
      </h2>
      <div aria-label="Особенности Серии плюс" className={styles['tabs']}>
        <Chips<number>
          options={tabOptions}
          padded={false}
          selectType="oneOf"
          value={[activeTabIndex]}
          onChange={onTabChange}
        />
      </div>
    </header>
  );
};
